module.exports = __webpack_public_path__ + "img/purchaseFailed.6b47a261.svg";